export const RESET_ADITIONAL_FIELDS = "RESET_ADITIONAL_FIELDS";
export const RESET_API_ADITIONAL_FIELDS = "RESET_API_ADITIONAL_FIELDS";
export const ADITIONAL_FIELDS_ERROR = "ADITIONAL_FIELDS_ERROR";
export const GET_ADITIONAL_FIELDS = "GET_ADITIONAL_FIELDS";
export const SET_ADITIONAL_FIELDS = "SET_ADITIONAL_FIELDS";
export const SET_CURRENT_CHAT_DATA = "SET_CURRENT_CHAT_DATA";
export const SAVE_ADITIONAL_FIELDS = "SAVE_ADITIONAL_FIELDS";
export const SAVE_ADITIONAL_FIELDS_SUCCESS = "SAVE_ADITIONAL_FIELDS_SUCCESS";
